import React from "react";
import { OperatorAccountInfoProvider } from "./OperatorAccountContext";
import OperatorAccountForm from "./OperatorAccountForm";

export const OperatorAccountInfoPage = () => {
  return (
    <OperatorAccountInfoProvider>
      <OperatorAccountForm />
    </OperatorAccountInfoProvider>
  );
};
